export const sanitizeForTestID = (value: string): string =>
  value.replace(/[^a-zA-Z0-9]+/g, '-');
